import React, { useEffect, useState, MouseEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import posthog from 'posthog-js';

import './scss/index.scss';
import Color from '@/tool/color';
import moUser from '@store/user';
import Service from '@/service';
import { init } from '@sentry/browser';
import { PoweredBy } from '@/styled/icon';
import moSkin from '@store/skin';

interface IProps {}
interface IState {}

const OutButton = styled(Button)(() => ({
  width: '150px',
  height: '36px',
  margin: '0 5px',
  fontSize: '14px',
  lineHeight: 1,
  borderRadius: '18px',
  border: `1px solid ${Color.fff}`,
  color: Color.fff,
}));

const Footer = (props: IProps, state: IState) => {
  const location = useLocation();
  const navi = useNavigate();
  const [partner, setPartner] = useState<string>('');
  const { isLogin, isStructureExpired, reportCount, isReportExpired, isAnalysisExpired } = moUser;
  const { scripts } = moSkin;

  useEffect(() => {
    const init = async () => {
      const res = await Service.getSkin();
      setPartner(res.partner);
      (document.getElementById('footer') as any).innerHTML = res.footerHtml;
      const doc = document;
      const link = doc.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('type', 'text/css');
      link.setAttribute('href', res.footerCss);
      const falink = doc.createElement('link');
      falink.setAttribute('rel', 'icon');
      falink.setAttribute('href', res.favicon);
      const heads = doc.getElementsByTagName('head');
      for (let i = 0; i < res?.scripts?.length; i++) {
        const bdlink = doc.createElement('script');
        bdlink.setAttribute('type', 'text/javascript');
        bdlink.setAttribute('charset', 'utf-8');
        bdlink.setAttribute('src', res.scripts[i]);
        if (heads.length > 0) {
          heads[0].appendChild(bdlink);
        } else {
          doc.documentElement.appendChild(bdlink);
        }
      }

      if (heads.length > 0) {
        heads[0].appendChild(link);
      } else {
        doc.documentElement.appendChild(link);
      }
      if (heads.length > 0) {
        heads[0].appendChild(falink);
      } else {
        doc.documentElement.appendChild(falink);
      }
    };
    init();
    return () => {};
  }, []);

  // 立即登录
  const onLogin = () => {
    posthog.capture('底部立即登录按钮', {});
    window.location.href = `/login?url_name=${location.pathname}`;
  };

  // 马上体验
  const onTry = () => {
    posthog.capture('首页-马上体验按钮', {});
    window.location.href = `/login?url_name=${location.pathname}`;
  };

  const onLink = (linkUrl: string) => {
    window.location.href = linkUrl;
  };

  const onBeiAn = () => {
    window.open('https://beian.miit.gov.cn/');
  };

  // 定制薪酬报告
  const onJumpCustomreport = () => {
    // posthog.capture('顶部导航栏跳转-定制薪酬报告', {});
    if (isLogin && reportCount > 0 && !isReportExpired) {
      window.location.href = '/customreport';
    } else {
      window.location.href = '/home/customreport';
    }
  };

  // 公司薪酬分析
  const onJumpCompensation = () => {
    // posthog.capture('顶部导航栏跳转-公司薪酬分析', {});
    if (isLogin && !isAnalysisExpired) window.location.href = '/compensation';
    else window.location.href = '/home/compensation';
  };

  // 薪酬体系设计
  const onJumpOveralldesign = () => {
    // posthog.capture('顶部导航栏跳转-薪酬体系设计', {});
    if (isLogin && !isStructureExpired) window.location.href = '/overalldesign';
    else window.location.href = '/home/overalldesign';
  };

  return (
    <section
      className="footers"
      style={{ position: 'relative', marginTop: '20px' }}>
      {partner !== 'smartsalary' && (
        <div
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            marginTop: '-10px',
          }}>
          <PoweredBy width={60} height={23} color={Color.white} />
        </div>
      )}
      <section
        id="footer"
        style={{ display: partner !== 'smartsalary' ? 'block' : 'none' }}/>
      <section
        className="footer-comp"
        style={{ display: partner === 'smartsalary' ? 'block' : 'none' }}>
        <section className="footer-container">
          <section className="footer-01">
            <i className="iconfont icon-a-logoxinzhi logo-11" />
            <section className="section-15">
              <section className="line-51">
                <b>联系我们</b>
                <section className="line-55">
                  <i className="iconfont icon-phone-fill icon-10"></i>
                  <p className="line-505">
                    <span>电话 / Phone Number</span>
                    <span>400 - 101 - 9070</span>
                  </p>
                </section>
                <section className="line-55">
                  <i className="iconfont icon-mail-fill icon-10"></i>
                  <p className="line-505">
                    <span>邮箱 / E-mail</span>
                    <span>service@smartsalary.cn</span>
                  </p>
                </section>
                <section className="line-55">
                  <i className="iconfont icon-location icon-10"></i>
                  <p className="line-505">
                    <span>地址 / Address</span>
                    <span>上海闵行区万源路2163号新桥商务中心A栋8楼</span>
                  </p>
                </section>
              </section>
              <section className="line-51">
                <b>人事相关工作</b>
                <span
                  aria-hidden="true"
                  className="link-10"
                  onClick={() => onLink('/market')}>
                  市场薪酬查询
                </span>
                <span
                  aria-hidden="true"
                  className="link-10"
                  onClick={onJumpCustomreport}>
                  定制薪酬报告
                </span>
                <span
                  aria-hidden="true"
                  className="link-10"
                  onClick={() => onLink('/home/institute')}>
                  薪酬研究院
                </span>
              </section>
              <section className="line-51">
                <b>薪酬设计、管理</b>
                <span
                  aria-hidden="true"
                  className="link-10"
                  onClick={onJumpCompensation}>
                  公司薪酬分析
                </span>
                <span
                  aria-hidden="true"
                  className="link-10"
                  onClick={onJumpOveralldesign}>
                  薪酬体系设计
                </span>
              </section>
              <section className="line-51">
                <b>开启您的薪酬管家</b>
                <span>建立专业的薪酬管理体系，保证团队薪酬内外竞争力</span>
                {!isLogin ? (
                  <p className="try-55">
                    <OutButton onClick={onLogin}>立即登录</OutButton>
                    <OutButton onClick={onTry}>马上体验</OutButton>
                  </p>
                ) : null}
              </section>
            </section>
          </section>

          <section className="footer-02">
            <p className="line-1006 hidden">
              <span
                aria-hidden="true"
                className="link-10"
                onClick={() => onLink('/home/institute?part=1')}>
                薪酬研究院
              </span>
              <b>&nbsp;&nbsp;|&nbsp;&nbsp;</b>
              <span
                aria-hidden="true"
                className="link-10"
                onClick={() => onLink('/home/customers')}>
                客户
              </span>
              <b>&nbsp;&nbsp;|&nbsp;&nbsp;</b>
              <span
                aria-hidden="true"
                className="link-10"
                onClick={() => onLink('/home/team')}>
                关于我们
              </span>
            </p>
            <section className="line-1005">
              <p>
                Copyright © 2017-{new Date().getFullYear()}{' '}
                薪郅互联网科技（上海）有限公司 版权所有
              </p>
              <p>
                <span aria-hidden="true" onClick={onBeiAn}>
                  沪ICP备18013079号-2
                </span>
              </p>
            </section>
            <p className="line-1006">
              <span
                aria-hidden="true"
                className="link-10"
                onClick={() => onLink('/home/institute?part=1')}>
                薪酬研究院
              </span>
              <b>&nbsp;&nbsp;|&nbsp;&nbsp;</b>
              <span
                aria-hidden="true"
                className="link-10"
                onClick={() => onLink('/home/customers')}>
                客户
              </span>
              <b>&nbsp;&nbsp;|&nbsp;&nbsp;</b>
              <span
                aria-hidden="true"
                className="link-10"
                onClick={() => onLink('/home/team')}>
                关于我们
              </span>
            </p>
          </section>

          <p className="footer-03">
            <span>友情链接:</span>
            <span
              aria-hidden="true"
              className="link-10"
              onClick={() => onLink('https://www.ersoft.cn/')}>
              人力资源云平台
            </span>
            <span
              aria-hidden="true"
              className="link-10"
              onClick={() => onLink('https://www.51echeck.com/')}>
              易查背调
            </span>
            <span
              aria-hidden="true"
              className="link-10"
              onClick={() => onLink('http://www.tophr.net/')}>
              第一资源
            </span>
          </p>
        </section>
      </section>
    </section>
  );
};

export default observer(Footer);
